var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedHeartratingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0012 47.25C26.3237 47.2491 25.6622 47.0444 25.1027 46.6625C16.8139 41.0358 13.2248 37.1777 11.2452 34.7657C7.02644 29.6241 5.00672 24.3454 5.06367 18.6289C5.13012 12.0783 10.3856 6.75 16.7791 6.75C21.4282 6.75 24.6482 9.36879 26.5234 11.5499C26.5828 11.6183 26.6562 11.6731 26.7386 11.7107C26.821 11.7483 26.9106 11.7677 27.0012 11.7677C27.0918 11.7677 27.1813 11.7483 27.2637 11.7107C27.3461 11.6731 27.4195 11.6183 27.4789 11.5499C29.3542 9.36668 32.5741 6.75 37.2232 6.75C43.6167 6.75 48.8722 12.0783 48.9387 18.63C48.9956 24.3475 46.9738 29.6262 42.7571 34.7667C40.7775 37.1788 37.1884 41.0368 28.8996 46.6636C28.34 47.0451 27.6785 47.2495 27.0012 47.25V47.25Z",
    fill: "#1B51BB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedHeartratingIcon);
export default __webpack_public_path__ + "static/media/selected_heartrating_icon.692b57d1f9de12aeae23e7bdcdc86092.svg";
export { ForwardRef as ReactComponent };